package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/** placeholder 读取 API，按 shortName 返回安全 entry。 */
fun interface PlaceholderApi {
    fun entry(shortName: String): PlaceholderEntry

    companion object {
        @JvmField
        val NOOP: PlaceholderApi = PlaceholderApi { PlaceholderEntry.unavailable() }
    }
}
